import {
    LINKEDIN_TOKEN_VALIDATED,
    UPDATE_EXTERNAL_IDS,
    UPDATE_ME,
    REGISTERED_SESSION_IDS_FETCHED
} from '../constants/ActionTypes';

function getInitialState() {
    return {
        me: {},
        isLinkedInTokenValid: true,
        isLinkedInTokenValidated: false,
        registeredSessionIds: null
    };
}

function MeReducer(state = getInitialState(), action = null) {
    switch (action.type) {
    case UPDATE_ME:
    {
        const me = Object.assign({}, state.me, action.me);
        return Object.assign({}, state, {me});
    }

    case LINKEDIN_TOKEN_VALIDATED:
        return Object.assign({}, state, {
            isLinkedInTokenValid: action.isValid,
            isLinkedInTokenValidated: true
        });

    case UPDATE_EXTERNAL_IDS:
    {
        const me = Object.assign({}, state.me, {[action.provider]: action.id});
        return Object.assign({}, state, {me});
    }

    case REGISTERED_SESSION_IDS_FETCHED: {
        return {...state, registeredSessionIds: action.payload};
    }

    default:
        return state;
    }
}

export default MeReducer;
